"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _of = require("rxjs/observable/of");

var _fromPromise = require("rxjs/observable/fromPromise");

var _filter = require("rxjs/operators/filter");

var _map = require("rxjs/operators/map");

var _mergeMap = require("rxjs/operators/mergeMap");

var _catchError = require("rxjs/operators/catchError");

var _concat = require("rxjs/operators/concat");

var _startWith = require("rxjs/operators/startWith");

var _reduxObservable = require("redux-observable");

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestStatusTypeFilters = require("settings-ui-sdk/constants/RequestStatusTypeFilters");

var _actions = require("settings-ui-sdk/PortalSettings/actions");

var _API = _interopRequireDefault(require("settings-ui-sdk/PortalSettings/API"));

var _actions2 = require("./actions");

var _API2 = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var fetchPortalSettings = function fetchPortalSettings() {
  return (0, _fromPromise.fromPromise)(_API.default.get()).pipe((0, _map.map)(function (response) {
    return _actions.FetchPortalSettings.success(response, {});
  }), (0, _catchError.catchError)(function (error) {
    return (0, _of.of)(_actions.FetchPortalSettings.failure(error, {}));
  }), (0, _startWith.startWith)(_actions.FetchPortalSettings.request({})));
};

var disableBccEmail = function disableBccEmail() {
  return (0, _fromPromise.fromPromise)(_API2.default.disableBccEmail()).pipe((0, _mergeMap.mergeMap)(function (response) {
    return (0, _concat.concat)(fetchPortalSettings())((0, _of.of)(_actions2.DisableBccEmail.success(response, {})));
  }), (0, _catchError.catchError)(function (error) {
    return (0, _of.of)(_actions2.DisableBccEmail.failure(error, {}));
  }), (0, _startWith.startWith)(_actions2.DisableBccEmail.request({})));
};

var sendBccEmailConfirmation = function sendBccEmailConfirmation(action) {
  var data = action.payload && action.payload.data ? action.payload.data : action.payload;
  return (0, _fromPromise.fromPromise)(_API2.default.sendBccEmailConfirmation(data)).pipe((0, _mergeMap.mergeMap)(function (response) {
    return (0, _concat.concat)(fetchPortalSettings())((0, _of.of)(_actions2.SendBccEmailConfirmation.success(response, data)));
  }), (0, _catchError.catchError)(function (error) {
    return (0, _of.of)(_actions2.SendBccEmailConfirmation.failure(error, data));
  }), (0, _startWith.startWith)(_actions2.SendBccEmailConfirmation.request({})));
};

var disableBccEmailEpic = function disableBccEmailEpic($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions2.BccEmailActionTypes.DISABLE_BCC_EMAIL).pipe((0, _filter.filter)(function () {
    var status = (0, _selectors.getDisableBccEmailRequestStatus)(getState());
    return _RequestStatusTypeFilters.ALLOW_MULTIPLE.indexOf(status) !== -1;
  }), (0, _mergeMap.mergeMap)(disableBccEmail));
};

var resendBccEmailConfirmationEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API2.default.resendBccEmailConfirmation,
  initiatingActionType: _actions2.BccEmailActionTypes.RESEND_BCC_EMAIL_CONFIRMATION,
  requestStatusSelector: _selectors.getResendBccEmailConfirmationRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_MULTIPLE,
  requestActions: _actions2.ResendBccEmailConfirmation
}));

var sendBccEmailConfirmationEpic = function sendBccEmailConfirmationEpic($action, _ref2) {
  var getState = _ref2.getState;
  return $action.ofType(_actions2.BccEmailActionTypes.SEND_BCC_EMAIL_CONFIRMATION).pipe((0, _filter.filter)(function () {
    var status = (0, _selectors.getSendBccEmailConfirmationRequestStatus)(getState());
    return _RequestStatusTypeFilters.ALLOW_MULTIPLE.indexOf(status) !== -1;
  }), (0, _mergeMap.mergeMap)(sendBccEmailConfirmation));
};

var _default = (0, _reduxObservable.combineEpics)(disableBccEmailEpic, resendBccEmailConfirmationEpic, sendBccEmailConfirmationEpic);

exports.default = _default;
module.exports = exports.default;